import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {
  Card,
  CardActions,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core'
import EditBtn from 'components/EditBtn'

const VideoResourceTable = (props) => {
  const { onPageChange, page, data } = props

  return (
    <Card>
      <CardContent className={'table-content'}>
        <PerfectScrollbar>
          <div className={'inner'}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Program ID</TableCell>
                  <TableCell>Workout ID</TableCell>
                  <TableCell>Subtitle</TableCell>
                  <TableCell>Week</TableCell>
                  <TableCell>Day</TableCell>
                  <TableCell>Active</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {((data && data.rows) || []).map(record => (
                    <TableRow key={record.id} hover>
                      <TableCell>{record.id}</TableCell>
                      <TableCell>{record.program_id}</TableCell>
                      <TableCell>{record.content_id}</TableCell>
                      <TableCell>{record.subtitle}</TableCell>
                      <TableCell>{record.week}</TableCell>
                      <TableCell>{record.sequence}</TableCell>
                      <TableCell>{record.active ? 'TRUE' : 'FALSE'}</TableCell>
                      <TableCell>
                        <EditBtn path={`/program-workouts/edit/${record.id}`} {...props} />
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={'flex-right'}>
        <TablePagination
          component="div"
          count={data.count || 0}
          onChangePage={onPageChange}
          page={page - 1}
          rowsPerPage={10}
          rowsPerPageOptions={[10]}
        />
      </CardActions>
    </Card>
  )
}

export default VideoResourceTable
